export default __webpack_public_path__ + "static/016-d5f51cb8b74a37b4e0828e83bf08d8a1.jpg";